(function(){
  var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  function toast(m){var t=$('#toast');if(!t)return;t.textContent=m;t.classList.add('on');clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('on')},2400)}
  function setCount(n){$$('[data-cart-count]').forEach(function(b){b.textContent=n;b.hidden=!n})}
  function refreshCount(){return fetch(HT.cartJson,{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){setCount(c.item_count)})}
  function add(body,label,btn){
    if(btn)btn.disabled=true;
    return fetch(HT.cartAdd,{method:'POST',headers:{Accept:'application/json'},body:body})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(x){
        if(!x.ok){toast(x.j.description||x.j.message||'Could not add to cart');return}
        toast((label||'Item')+' added to cart');return refreshCount();
      }).catch(function(){toast('Could not add to cart')})
      .then(function(){if(btn)btn.disabled=false});
  }

  /* mobile menu */
  var bg=$('#burger'),mn=$('#menu');
  if(bg&&mn){
    bg.addEventListener('click',function(){var o=mn.classList.toggle('open');bg.setAttribute('aria-expanded',o)});
    mn.addEventListener('click',function(e){if(e.target.tagName==='A'){mn.classList.remove('open');bg.setAttribute('aria-expanded','false')}});
  }

  /* quick add on cards */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-quick-add]');if(!b)return;
    var fd=new FormData();fd.append('id',b.getAttribute('data-quick-add'));fd.append('quantity','1');
    add(fd,b.getAttribute('data-title'),b);
  });

  /* product page form: ajax add */
  document.addEventListener('submit',function(e){
    var f=e.target.closest('form[data-ajax-cart]');if(!f)return;
    e.preventDefault();
    var t=$('h1',document);
    add(new FormData(f),t?t.textContent.trim():'Item',$('[data-add-btn]',f));
  });

  /* tabs on product rows */
  $$('[data-tab]').forEach(function(tab){
    tab.addEventListener('click',function(){
      var sec=tab.closest('section');
      $$('[data-tab]',sec).forEach(function(t){t.setAttribute('aria-pressed',t===tab)});
      $$('[data-panel]',sec).forEach(function(p){p.hidden=p.getAttribute('data-panel')!==tab.getAttribute('data-tab')});
    });
  });

  /* collection sort */
  var sort=$('[data-sort]');
  if(sort)sort.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',sort.value);u.searchParams.delete('page');location.href=u.toString()});

  /* product page: gallery + variants */
  var pf=$('[data-product-form]');
  if(pf){
    var raw=$('[data-variants]',pf),variants=raw?JSON.parse(raw.textContent):[];
    function showImage(id){
      var slides=$$('.gal-slide',pf);if(!id||!slides.length)return;
      slides.forEach(function(s){s.hidden=String(s.getAttribute('data-image-id'))!==String(id)});
      $$('[data-thumb]',pf).forEach(function(t){t.setAttribute('aria-current',String(t.getAttribute('data-thumb'))===String(id))});
    }
    $$('[data-thumb]',pf).forEach(function(t){t.addEventListener('click',function(){showImage(t.getAttribute('data-thumb'))})});
    var first=$('[data-thumb]',pf);if(first)first.setAttribute('aria-current','true');
    function onOption(){
      var chosen=$$('.pills input:checked',pf).map(function(i){return i.value});
      var v=variants.filter(function(x){return x.options.join('|')===chosen.join('|')})[0];
      var btn=$('[data-add-btn]',pf),price=$('[data-price]',pf);
      if(!v){btn.disabled=true;btn.textContent='Unavailable';return}
      $('[data-variant-id]',pf).value=v.id;
      price.innerHTML=v.compare?'<s>'+v.compare+'</s> <span class="sale">'+v.price+'</span>':v.price;
      btn.disabled=!v.available;btn.textContent=v.available?'Add to cart':'Sold out';
      if(v.image)showImage(v.image);
      history.replaceState(null,'','?variant='+v.id);
    }
    $$('.pills input',pf).forEach(function(i){i.addEventListener('change',onOption)});
  }
})();
